import acInterceptor from '../acInterceptor';
import { useRequest } from 'alova';

import { GenerateBilletResponse } from './types';

const headers = {
  'Content-Type': 'application/json;charset=UTF-8',
  'Access-Control-Allow-Origin': '*',
};

const useApiBillet = (msUrl: string) => {
  const isGeminio = msUrl?.includes('geminio');

  const baseURL = isGeminio ? msUrl : import.meta.env.VITE_OFFERS_HUB_API;
  const currHeaders = !isGeminio ? headers : {};

  const apiGenerateBillet = useRequest(
    (payload) => {
      const path = isGeminio
        ? '/api/v2/billet'
        : `v1/app/paymentslip`;

      return acInterceptor({
        baseURL,
      }).Post<GenerateBilletResponse>(path, payload, {
        headers: currHeaders,
        transformData: (data: any) => (!isGeminio && data?.data ? data.data : data),
      });
    },
    {
      immediate: false,
    }
  );

  return {
    apiGenerateBillet,
  };
};

export default useApiBillet;
